import { ElementRef } from '@angular/core';

export class ElementProvider {
    constructor(private elementRef: ElementRef<HTMLElement>) {}

    get element(): ElementRef<HTMLElement> {
        return this.elementRef;
    }
}
